import { RSAA } from 'redux-api-middleware';
import config from 'config';

const LOGGED_IN_USER_STORE_KEY = "logged_in_user";
const BACKEND_COMMIT_VERSION_ID = "commit_version_id";
const BACKEND_RELEASE_NUMBER = "release_number";
const DEVICE_ID_STORE_KEY = "device_id";
const TOKEN_CREATION_TIME_STORE_KEY = "token_creation_time";
const TOKEN_EXPIRATION_TIME_STORE_KEY = "token_expiration_time";
const CSRF_TOKEN_STORE_KEY = "csrf_token";
export const CSRF_TOKEN_HEADER_KEY = "X-Csrf-Token";

export const TOKEN_REQUEST = '@@auth/TOKEN_REQUEST';
export const TOKEN_RECEIVED = '@@auth/TOKEN_RECEIVED';
export const TOKEN_FAILURE = '@@auth/TOKEN_FAILURE';

function createPromise(handler){
  var resolve, reject;

  var promise = new Promise(function(_resolve, _reject){
    resolve = _resolve;
    reject = _reject;
    if(handler) handler(resolve, reject);
  })

  promise.resolve = resolve;
  promise.reject = reject;
  return promise;
}

// create
var backendBuildVersionPromise = createPromise(resolveIfBuildVersionAvailable);
var backendReleaseNumberPromise = createPromise(resolveIfReleasNumbereAvailable);

function resolveIfBuildVersionAvailable(resolve, reject) {
  if(localStorage.getItem(BACKEND_COMMIT_VERSION_ID))
    resolve(localStorage.getItem(BACKEND_COMMIT_VERSION_ID));
}

function resolveIfReleasNumbereAvailable(resolve, reject) {
  if(localStorage.getItem(BACKEND_RELEASE_NUMBER))
    resolve(localStorage.getItem(BACKEND_RELEASE_NUMBER));
}

export const refreshAccessToken = () => ({
  [RSAA]: {
    endpoint: `${config.apiRoot}/login/refresh-token`,
    method: 'POST',
    body: JSON.stringify({
      email: getLoggedInUser().email,
      deviceId: getDeviceKey()
    }),
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    types: [
      TOKEN_REQUEST, TOKEN_RECEIVED, TOKEN_FAILURE
    ]
  }
})

export function isAccessTokenExpired() {
  const start = Number(localStorage.getItem(TOKEN_CREATION_TIME_STORE_KEY));
  const seconds = Number(localStorage.getItem(TOKEN_EXPIRATION_TIME_STORE_KEY));

  // If data is missing or current time exceeds (start + duration - 5s buffer)
  return !start || !seconds || Date.now() > (start + (seconds * 1000) - 5000);
}


export function updateAccessTokenExpirationTime(currentTimeMillis, idTokenDurationSecs) {
  localStorage.setItem(TOKEN_EXPIRATION_TIME_STORE_KEY, idTokenDurationSecs);
  localStorage.setItem(TOKEN_CREATION_TIME_STORE_KEY, currentTimeMillis);
}



export function isAuthenticated() {
  const start = Number(localStorage.getItem(TOKEN_CREATION_TIME_STORE_KEY));
  const seconds = Number(localStorage.getItem(TOKEN_EXPIRATION_TIME_STORE_KEY));

  return !!(start && seconds);
}

export function updateDeviceId(deviceKey) {
  localStorage.setItem(DEVICE_ID_STORE_KEY, deviceKey);
}

export function getDeviceKey(){
  return localStorage.getItem(DEVICE_ID_STORE_KEY);
}

export function getLoggedInUser(){
  return JSON.parse(localStorage.getItem(LOGGED_IN_USER_STORE_KEY));
}

export function getBackendCommitVersionIdPromise(){
  return backendBuildVersionPromise;
}

export function getBackendReleaseNumberPromise(){
  return backendReleaseNumberPromise;
}

export function logoutUser(redirectCallback) {
    localStorage.clear();
    if (typeof redirectCallback === 'function') redirectCallback();
    window.location.reload(true);
}

export function loginUser(response) {
  const backend_commit_version_id = response.data.commitVersionId;
  const backend_release_number = response.data.currentReleaseNumber;

  localStorage.setItem(BACKEND_COMMIT_VERSION_ID, backend_commit_version_id);
  localStorage.setItem(BACKEND_RELEASE_NUMBER, backend_release_number);
  localStorage.setItem(LOGGED_IN_USER_STORE_KEY, JSON.stringify(response.data));

  backendBuildVersionPromise.resolve(backend_commit_version_id);
  backendReleaseNumberPromise.resolve(backend_release_number);
}

export function updateCsrfToken(csrfToken) {
  localStorage.setItem(CSRF_TOKEN_STORE_KEY, csrfToken);
}

export function getCsrfToken() {
  return localStorage.getItem(CSRF_TOKEN_STORE_KEY);
}

export function cognitoLoginSuccess(
  loggedInUserData,
  backend_commit_version_id,
  backend_release_number,
  deviceKey,
  currentTimeMillis,
  idTokenDurationSecs,
  csrfToken
) {
  localStorage.setItem(LOGGED_IN_USER_STORE_KEY, JSON.stringify(loggedInUserData));
  localStorage.setItem(BACKEND_COMMIT_VERSION_ID, backend_commit_version_id);
  localStorage.setItem(BACKEND_RELEASE_NUMBER, backend_release_number);
  localStorage.setItem(DEVICE_ID_STORE_KEY, deviceKey);
  updateAccessTokenExpirationTime(currentTimeMillis, idTokenDurationSecs);
  updateCsrfToken(csrfToken);
  backendBuildVersionPromise.resolve(backend_commit_version_id);
  backendReleaseNumberPromise.resolve(backend_release_number);
}
